import React, { useState, useEffect } from "react" ;
import { useRecoilState } from 'recoil';

import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { getChildThemes } from "root/DataFunctions/ChildDataFns";
import { childDrawerState } from 'root/recoil/childDrawerState';

import ThemeImage from "./ThemeImage";

import '../styles/themeDrawer.scss';
import closeIcon from "../assets/icons/close.png";

const themeDrawer = () => {
    const [themes, setThemes] = useState(null);
    const [childDrawer, setChildDrawer] = useRecoilState(childDrawerState);
    
    useEffect(() => {
        getChildThemes(response =>
        {
            setThemes(getDataFromResponse(response));
        });
    }, []);

    return (
        themes ? <div>
            <div className={childDrawer ? "sideDrawer active" : "sideDrawer"}>
                <div className="sideDrawer_theme_header">
                    <h2 className="title">Choose a background</h2>
                    <button onClick={ () => setChildDrawer(!childDrawer) } className="close_button">
                        <img className="icon" src={closeIcon} alt="Close Icon" />
                    </button>
                </div>
                <div className="sideDrawer_items">
                    {themes ? themes.map((theme)=>
                        <ThemeImage key={theme.id} theme={theme} />
                    ) : <p>Loading...</p>}
                </div>
            </div>
            <div 
                onClick={ () => setChildDrawer(!childDrawer) }
                className={childDrawer ? "drawer_overlay active" : "drawer_overlay"}
            ></div>
        </div> : <p>Loading...</p>
    )
}

export default themeDrawer;